export enum SupplierOrderFields {
    User = 'codUsuario',
    ProviderId = 'codProveedor',
    Provider = 'descProveedor',
    Items = 'pedido',
    DestinationClient = 'clienteDestino',
    StatusCode = 'codEstado',
    StatusDesc = 'descEstado',
    CreatedDate = 'fechaAlta',
    LastModifiedDate = 'fechaUltMod',
    DeliveryDate = 'fechaEntrega',
    Transport = 'transporteEnvio',
    ResponsibleUserId = 'codUsuarioResponsable',
    ResponsibleUserName = 'nombreUsuarioResponsable',
    CommunicationChannelCode = 'codCanalComunicacion',
    CommunicationChannel = 'descCanalComunicacion',
    RequestDate = 'fechaSolicitud',
    DaysSinceCreation = 'diasDesdeAlta',
    EstimatedAmount = 'importeEstimado',
}

export enum SupplierOrderFilterFields {
    Items = 'pedido',
    DestinationClient = 'clienteDestino',
    ProviderId = 'codProveedor',
    StatusCodeList = 'estados',
    CreatedDateStart = 'fechaAltaDesde',
    CreatedDateEnd = 'fechaAltaHasta',
    DeliveryDateStart = 'fechaEntregaDesde',
    DeliveryDateEnd = 'fechaEntregaHasta',
    ResponsibleUser = 'codUsuarioResponsable',
}

export enum SupplierOrderHistoryFields {
    HistoryDate = 'fechaHistoria',
    ModifiedBy = 'usuarioModificacion',
    Items = 'pedido',
    DestinationClient = 'clienteDestino',
    Transport = 'transporte',
    ProviderName = 'nombreProveedor',
    StatusDesc = 'descEstado',
    StatusCode = 'codEstado',
    DeliveryDate = 'fechaEntrega',
    RequestDate = 'fechaSolicitud',
    ResponsibleName = 'nombreResponsable',
    CommChannelDesc = 'descCanalComunicacion',
    EstimatedAmount = 'importeEstimado',
}